import React, { useState, useEffect, useRef } from 'react';
import { Button, Flex, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export const ExportsControls = ({ onRefetch, loading }) => {
    const [isCooldown, setIsCooldown] = useState<boolean>(false);
    const prevLoadingRef = useRef<boolean>(loading);

    const navigate = useNavigate();

    useEffect(() => {
        if (prevLoadingRef.current && !loading) {
            setIsCooldown(true);
            const timer = setTimeout(() => {
                setIsCooldown(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
        prevLoadingRef.current = loading;
    }, [loading]);

    return (
        <Flex justify={'space-between'} align={'center'}>
            <Title style={{ margin: 0 }} level={4}>
                Последние выгрузки
            </Title>
            <Flex gap={8}>
                <Button
                    disabled={loading}
                    loading={loading}
                    onClick={() => navigate('create')}
                    icon={<DownloadOutlined />}
                >
                    Создать выгрузку
                </Button>
                <Button
                    disabled={loading || isCooldown}
                    loading={loading}
                    onClick={onRefetch}
                >
                    Обновить выгрузку
                </Button>
            </Flex>
        </Flex>
    );
};
